import axios from "axios";
import Constants from "../../../components.constants.js";

export default {
  async downloadFile(context, payload = {}) {
    try {
      const config = { responseType: "blob" };
      let resp = await axios.get(
        `${Constants.downloadUrl}?${payload.job_id}`,
        config
      );
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status;
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[downloadFile][Store][Error occured while downloading file--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401) {
          return context.dispatch("users/logOutFromServer", {}, { root: true });
        } else {
          error.response.data.statusCode = error.response.status;
          return error.response.data;
        }
      }
      return {};
    }
  },

  async initiateDownloadJob(context, payload = {}) {
    try {
      let resp = await axios.post(`${Constants.jobsUrl}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[initiateDownloadJob][Store][Download file job resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status;
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[initiateDownloadJob][Store][Error occured while downloading file--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401) {
          return context.dispatch("logOutFromServer");
        } else {
          error.response.data.statusCode = error.response.status;
          return error.response.data;
        }
      }
      return {};
    }
  },
};
